import React from "react";

// Kit button: pick a variant by what the button does, a size by where it sits.
//   primary       the one main action on a screen / dialog (save, post, log in)
//   secondary     filled (button fill + visible border): cancel / back / alternatives; row & card actions at sm
//   tertiary      outline, lower emphasis (close, clear filters, load more, fallbacks): page-color fill, main-text border + text
//   danger        reversible danger (decline, leave, log out, cancel)
//   danger-strong solid red: any irreversible action (delete account / event / data), both the trigger and its confirm
// Sizes: sm 32px (rows, cards, header "+ new"), md 40px (forms, panels, dialogs), lg 48px (page-level / full-width).
// Styles: .inyc-btn in src/styles/kit-controls.css.
const VARIANTS = ["primary", "secondary", "tertiary", "danger", "danger-strong"];
const SIZES = ["sm", "md", "lg"];

const ICON_PX = { sm: 14, md: 16, lg: 18 };

export const Spinner = ({ size = 16 }) => (
  <span
    aria-hidden="true"
    className="inline-block shrink-0 animate-spin rounded-kit-full border-[2px] border-current border-r-transparent"
    style={{ width: size, height: size }}
  />
);

const Button = ({
  variant = "secondary",
  size = "md",
  icon = null,
  iconRight = null,
  fullWidth = false,
  loading = false,
  disabled = false,
  type = "button",
  className = "",
  children,
  ...rest
}) => {
  const iconPx = ICON_PX[size] || 16;
  const withSize = (node) => (React.isValidElement(node) && node.props.size == null ? React.cloneElement(node, { size: iconPx }) : node);
  return (
    <button
      type={type}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={`inyc-btn is-${VARIANTS.includes(variant) ? variant : "secondary"} is-${SIZES.includes(size) ? size : "md"} ${
        fullWidth ? "is-full" : ""
      } ${className}`.trim()}
      {...rest}
    >
      {loading ? <Spinner size={iconPx} /> : withSize(icon)}
      {children != null && children !== false && <span>{children}</span>}
      {!loading && withSize(iconRight)}
    </button>
  );
};

export default Button;
